import * as React from 'react'
import * as ReactDOM from 'react-dom/client'

import applyGlobalAxiosInterceptors, { API } from './app/configs/axios/axios.config'
import applyNotificationConfig from './app/configs/notification.config'
import createStore from './app/store/store'
import App from './app/app'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

export const { store, persistor } = createStore()

// Note: Theme configuration is handled dynamically in App.jsx to support dark mode
// The ConfigProvider with theme algorithm is inside App component

applyGlobalAxiosInterceptors(API)
applyNotificationConfig()

const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)

const render = () => {
    root.render(
        // <StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App store={store} />
            </PersistGate>
        </Provider>,
        // </StrictMode>,
    )
}

render()
